/* NANEND 2026-10-09 — mobile only: pin the Seel button to its final bottom-left
   spot so it can never render at the vendor's intermediate (higher) position.
   The vendor mounts the icon inside shadow DOM, parks it ~60px too high, then
   slides it down. Instead of waiting for that animation, we force the icon's
   own inline position (left/bottom, top/right auto) as soon as it exists and
   keep re-forcing it for the first seconds, then reveal instantly.
   No JS / no widget => nothing changes (fallback force-shows after 4s). */
(function () {
  try {
    if (!window.matchMedia || !window.matchMedia('(max-width: 768px)').matches) return;
    var root = document.documentElement;
    root.classList.add('nanend-seel-armed');

    var LOCK = { position: 'fixed', left: '20px', bottom: '12px', top: 'auto', right: 'auto' };

    function host() { return document.getElementById('seel-ai-support'); }

    function lockEl(el) {
      for (var k in LOCK) {
        if (el.style.getPropertyValue(k) !== LOCK[k]) el.style.setProperty(k, LOCK[k], 'important');
      }
    }

    var revealed = false, t0 = Date.now();

    function tick() {
      var h = host();
      if (h && h.shadowRoot) {
        var el = h.shadowRoot.querySelector('.seel_ai_support_icon') ||
                 h.shadowRoot.firstElementChild;
        if (el) {
          var b = el.getBoundingClientRect();
          if (b.width > 8 && b.height > 8) {
            lockEl(el);
            if (!revealed) {
              revealed = true;
              h.classList.add('nanend-seel-ready');
            }
          }
        }
      }
      var t = Date.now() - t0;
      if (!revealed && t > 4000) {           // safety: never stay hidden
        revealed = true;
        var h2 = host();
        if (h2) h2.classList.add('nanend-seel-ready');
      }
      if (t > 8000) clearInterval(timer);    // stop re-forcing after 8s
    }
    var timer = setInterval(tick, 40);
    tick();
  } catch (e) {}
})();
